module.exports = __webpack_public_path__ + "img/thumbnail_AmericanBison_j_normal.38551471.png";